import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CarouselModule } from 'primeng/carousel';
import { ButtonModule } from 'primeng/button';
import { RendererComponent } from './renderer/renderer.component';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { PasswordModule } from 'primeng/password';
import { BadgeModule } from 'primeng/badge';
import { ChipModule } from 'primeng/chip';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CardModule } from 'primeng/card';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { TabViewModule } from 'primeng/tabview';
import { AccordionModule } from 'primeng/accordion';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { FieldsetModule } from 'primeng/fieldset';
import { PhonePipe } from 'briteatlib';

const primengComponents = [
  CardModule,
  ButtonModule,
  CarouselModule,
  DialogModule,
  DynamicDialogModule,
  RadioButtonModule,
  CheckboxModule,
  InputTextModule,
  PasswordModule,
  BadgeModule,
  ChipModule,
  InputGroupModule,
  InputGroupAddonModule,
  AutoCompleteModule,
  InputTextareaModule,
  MenuModule,
  TabViewModule,
  AccordionModule,
  ToggleButtonModule,
  FieldsetModule
]

const modules = [
  CommonModule,
  RouterModule,
  FormsModule,
  ...primengComponents,
  PhonePipe
];
const components = [
  RendererComponent
];

@NgModule({
  declarations: [
    ...components
  ],
  imports: [...modules],
  exports: [
    ...modules,
    ...components
  ],
  providers: []
})
export class SharedModule { }
